<template>
	<div :style="style">
		<div class="section-title horizontal-center">
			<img class="mr-10" :src="require('@/assets/top_news_icon.svg')"/>
			<span>お知らせ</span>
		</div>

		<swiper v-if="fixTops.length > 0" :options="fixTopSwiperOption" class="swiper fixTopSwiper">
			<swiper-slide v-for="(row, index) in fixTops" :key="index">
				<div class="fix-top-wrap" :style="fixTopBgColor(row)">
					<common-avatar :width="89" :name="row.name" :image="row.avatar" :staffId="row.id" :teamId="row.id" :isTeam="row.is_newteam"></common-avatar>
					<div class="fix-top-type horizontal-center-center">
						<img class="ribbon" :src="fixTopBgRibbon(row)"/>
						<img class="icon" :src="fixTopTypeIcon(row)"/>
						<span class="bold18">{{ fixTopTypeText(row) }}</span>
					</div>
					<div class="name">{{ row.name }}</div>
				</div>
			</swiper-slide>
			<div class="swiper-button-prev" slot="button-prev"></div>
			<div class="swiper-button-next" slot="button-next"></div>
		</swiper>
		
		<div v-if="informations.length > 0" class="information-area mt-30">
			<div v-for="(row, index) in informations" :key="index" @click="$router.push({ name: 'information', params: { informationId: row.id }})">
				<div class="information-wrap horizontal-center" v-if="index < 2 || isInformationAllShow">
					<div class="preview-area">
						<preview v-show="row.thumbnail_image" :image="row.thumbnail_image" :maxH="104"></preview>
					</div>
					<span class="bold18 information-title" v-html="$utils.ellipsis(row.title, 30)"></span>
				</div>
			</div>

			<div class="information-wrap horizontal-center" v-if="isInformationDummyShow" style="visibility: hidden">
			</div>
		</div>

		<div v-if="informations.length > 0" class="text-center mt-20">
			<b-button type="is-primary" rounded @click="isInformationAllShow = true" v-show="!isInformationAllShow && informations.length > 2">＋もっと見る</b-button>
		</div>
		<div v-else class="mt-10">運営からのお知らせはありません</div>

		<div class="section-title horizontal-center mt-30">
			<img class="mr-10" :src="require('@/assets/top_news_icon.svg')"/>
			<span>みんなの記事</span>
		</div>

		<div v-if="news.list && news.list.length > 0">
			<swiper :options="newsSwiperOption" class="swiper newsSwiper">
				<swiper-slide v-for="(row, index) in news.list" :key="index">
					<news-summary :data="row" :isEditShow="false" :isCategoryShow="true" @click="$router.push({ name: 'news-view', params: { newsId: row.id, token: $consts.DUMMY_TOKEN }})"></news-summary>
				</swiper-slide>
				<div class="swiper-button-prev" slot="button-prev"></div>
				<div class="swiper-button-next" slot="button-next"></div>
			</swiper>

			<div class="text-center mt-20">
				<b-button type="is-primary" rounded @click="$router.push({ name: 'news' })">記事一覧を見る</b-button>
			</div>
		</div>
		<div v-else>記事はありません</div>

		<div class="section-title mt-30">7Coins</div>

		<div v-if="coins.list && coins.list.length > 0" class="coin-card-wrap">
			<coin-card
				v-for="(row, index) in coins.list"
				:key="index"
				:isTeam="row.is_team"
				:isMember="row.is_member"
				:id="row.id"
				:coin="row.coin"
				:comment="row.comment"
				:commentEllipsis="30"
				:to="row.is_team ? row.to_team : row.to_staff"
				:from="row.from"
				:created="row.created"
				:likeCount="row.like_count"
				:isLiked="row.is_liked"
				:isEditShow="row.from.id === $store.state.auth.id"
				@edit-click="$router.push({ name: 'coin-present-to', params: { coinPresentId: row.id }})"
				@comment-click="$router.push({ name: '7coins', params: { coinPresentId: row.id }})"
			></coin-card>

			<coin-card
				v-for="n in coinDummy"
				:key="`card-dummy-${n}`"
				class="coin-card-dummy"
				:to="coinDummyData"
				:from="coinDummyData"
				style="visibility: hidden;"
			></coin-card>

		</div>
		<div v-else>コインはありません</div>

		<split-loader class="mt-10" :windowH="windowH" :isLoading="isSplitLoading" @base-touch="onBaseTouch"></split-loader>
	</div>
</template>

<style lang="scss" scoped>
@import '@/scss/_vars.scss';

.coin-card-wrap{
	.sv-coin-card {
		margin-top: 10px;
	}
}

.information-wrap {
	background: #fff;
	border-radius: 5px;
	padding: 5px;
	margin-top: 10px;

	.information-title {
		color: $titleColor;

		/deep/ .ellipsis { //v-html要素にscopedから適用させるための記述
			font-weight: normal;
			font-size: 15px;
		}
	}

	.preview-area {
		min-width: 104px;
		max-width: 104px;
		min-height: 104px;
		max-height: 104px;
		background: $gray;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-right: 10px;
	}
}

.swiper {
	margin-left: -$basePadding;
	margin-right: -$basePadding;
}

.fixTopSwiper {
	.fix-top-wrap {
		background: #fff;
		border-radius: 10px;
		width: 97%;
		padding: 10px 0;

		.fix-top-type {
			position: relative;
			margin: 5px 0 10px 0;
			padding-top: 5px;

			span {
				color: #fff;
				margin-left: 2px;
				z-index: 1;
				font-size: 15px;
			}

			img.icon {
				z-index: 1;
				width: 20px;
				height: 20px;
			}

			img.ribbon {
				position: absolute;
				top: 0;
				left: 0;
				width: 121px;
				height: 27px;
			}
		}

		.name {
			font-weight: bold;
			text-align: center;
		}
	}
}

.newsSwiper {
	.news-summary {
		margin: 0 $basePadding;
	}
}

@media screen and (min-width: $breakPoint) {
.coin-card-wrap {
	display: flex;
	justify-content: space-around;
	flex-wrap: wrap;

	.sv-coin-card {
		width: 301px;
		margin-top: 20px;
	}
}

.fixTopSwiper {
	.fix-top-wrap {
		width: 222px;
		padding: 30px 0;

		/deep/ .avatar {
			img {
				width: 170px !important;
			}
		}

		.fix-top-type {
			padding-top: 10px;
			margin: 20px 0;

			img.icon {
				width: 40px;
				height: 40px;
			}

			img.ribbon {
				width: 100%;
				height: 51px;
			}

			span {
				font-size: 26px;
			}
		}
	}
}

$previewMax: 192px;
.information-area {
	display: flex;
	align-items: center;
	justify-content: space-around;
	flex-wrap: wrap;

	.information-wrap {
		width: 624px;
		height: 230px;
		padding-left: 15px;
		margin-top: 20px;

		.preview-area {
			max-height: $previewMax !important;
			min-height: $previewMax !important;
			max-width: $previewMax !important;
			min-width: $previewMax !important;

			/deep/ .sv-preview {
				img {
					max-height: $previewMax !important;
				}
			}
		}
	}
}

.newsSwiper {
	.news-summary {
		width: 610px;
	}

	/deep/ .news-preview {
		text-align: left;
	}
}

}

</style>

<script>
import 'swiper/dist/css/swiper.css'

import { swiper, swiperSlide } from 'vue-awesome-swiper'
import CommonAvatar from '@/components/CommonAvatar'
import Preview from '@/components/Preview'
import NewsSummary from '@/components/NewsSummary'
import CoinCard from '@/components/CoinCard'
import SplitLoader from '@/components/SplitLoader'

export default {
	name: 'Top',
	components: {
		swiper,
		swiperSlide,
		CommonAvatar,
		Preview,
		NewsSummary,
		CoinCard,
		SplitLoader,
	},
	data () {
		return {
			fixTops: [],
			fixTopSwiperOption: {},
			informations: [],
			coins: [],
			news: [],
			isInformationAllShow: false,
			newsSwiperOption: {},
			isSplitLoading: false,
			windowH: 0,
			coinDummy: 0,
			coinDummyData: {
				id: '',
				name: '',
				avatar: '',
			},
		}
	},
	created() {
		let delay = 7000;
		this.fixTopSwiperOption = {
			slidesPerView: this.$utils.isSp() ? 3 : 6,
			autoplay: {
				delay: delay,
				disableOnInteraction: false,
			},
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev'
			},
		};

		this.newsSwiperOption = {
			slidesPerView: this.$utils.isSp() ? 1 : 2,
			autoplay: {
				delay: delay,
				disableOnInteraction: false,
			},
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev'
			},
		};
	},
	mounted() {
		this.init();

		this.windowH = document.getElementsByTagName('html')[0].clientHeight;

		//setTimeout(function() {
		//	window.scrollBy(0, 4000);
		//},1000);
	},
	watch: {
		isSplitLoading: function(to, from) {
			if (to) return;
			if (this.$store.state.savedScrollPositionY <= 0) return;

			if (document.body.scrollHeight < this.$store.state.savedScrollPositionY) {
				this.onBaseTouch();
				return;
			}
			this.$nextTick(() => {
					var positionY = this.$store.state.savedScrollPositionY;
					scrollTo(0, positionY);
					setTimeout(function(){
							scrollTo(0, positionY);
					}, 500);
			});
		}
	},
	computed: {
		isInformationDummyShow: function() {
			return this.informations.length >= 3 && this.isInformationAllShow && this.informations.length % 2 !== 0;
		},
		style: function() {
			return !this.$utils.isSp() ? { 'margin-right': '-60px', 'margin-left': '-60px' } : '';
		}
	},
	methods: {
		fixTopBgRibbon: function(row) {
			if (row.is_newface) {
				return require('@/assets/icons/new_face_ribbon.svg');
			}
			if (row.is_newteam) {
				return require('@/assets/icons/new_team_ribbon.svg');
			}
			if (row.is_birthday) {
				return require('@/assets/icons/birthday_ribbon.svg');
			}
			if (row.is_birthday_eve) {
				return require('@/assets/icons/birthday_eve_ribbon.svg');
			}
		},
		fixTopBgColor: function(row) {
			if (row.is_newface) {
				return { 'background': 'linear-gradient(to bottom, #4ED6A2, #CAF2E1)' };
			}
			if (row.is_newteam) {
				return { 'background': 'linear-gradient(to bottom, #54C1EA, #D1EEF8)' };
			}
			if (row.is_birthday) {
				return { 'background': 'linear-gradient(to bottom, #FF9FA7, #FFDDDD)' };
			}
			if (row.is_birthday_eve) {
				return { 'background': 'linear-gradient(to bottom, #FF9FA7, #FFDDDD)' };
			}
		},
		onBaseTouch: async function(index) {
			this.$utils.log('onBottomTouch');
			this.$utils.log(typeof this.coins.last_id === 'undefined');
			if (typeof this.coins.last_id === 'undefined' || this.coins.last_id === '') {
				return;
			}
			this.isSplitLoading = true;

			let ep = `present-coins/index?last_id=${this.coins.last_id}`;
			this.$utils.log(ep);

			try {
				let res = await this.$api.get(ep, null, true);
				this.$utils.log(res);
				let tmp = this.coins.list.concat(res.data.list);
				this.coins.list = tmp;
				this.updateCoinDummy();
				this.coins.last_id = res.data.last_id;
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
			} finally {
				this.isSplitLoading = false;
			}
		},
		fixTopTypeIcon: function(data) {
			let name;
			if (data.is_birthday) {
				name = 'birthday';
			}
			if (data.is_birthday_eve) {
				name = 'birthday_eve';
			}
			if (data.is_newface) {
				name = 'new_face';
			}
			if (data.is_newteam) {
				name = 'new_team';
			}

			return require('@/assets/icons/' + name + '.svg');
		},
		fixTopTypeText: function(data) {
			let name;
			if (data.is_birthday) {
				name = '誕生日';
			}
			if (data.is_birthday_eve) {
				name = '誕生日イブ';
			}
			if (data.is_newface) {
				name = '新顔';
			}
			if (data.is_newteam) {
				name = '新チーム';
			}

			return name;
		},
		updateCoinDummy: function() {
			if (this.$utils.isSp()) return;
			this.coinDummy = this.coins.list.length > 4 ? 4 - (this.coins.list.length % 4) : 0;
		},
		init: function() {
			this.getData();
		},
		getData: async function() {
			let loader = this.$buefy.loading.open();
			let ep = 'tops/';
			this.$utils.log(ep);

			try {
				let res = await this.$api.get(ep, null, true);
				this.$utils.log(res);
				this.fixTops = res.data.fix_tops;
				this.informations = res.data.informations;
				this.coins = res.data.coins;
				this.updateCoinDummy();
				this.news = res.data.news;
				if (this.$utils.isIOS()) {
					this.$nextTick(() => {
						window.scrollTo(0, 1)
						window.scrollTo(0, 0)
					});
				}
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
			} finally {
				loader.close();
			}
		},
	}
}
</script>
